import styled from 'styled-components';

interface Props {
  title: string;
  description: string;
  noticeIcon: React.ReactNode;
  button?: React.ReactNode;
}
const EmptyNeighborhoodSearchResult = ({
  title,
  description,
  noticeIcon,
  button,
}: Props) => {
  return (
    <Wrapper>
      <EmptyResultWrapper>
        <EmptyResultTitle>{title}</EmptyResultTitle>
        <EmptyResultOffer>{description}</EmptyResultOffer>
        {noticeIcon}
        {button}
      </EmptyResultWrapper>
    </Wrapper>
  );
};

export default EmptyNeighborhoodSearchResult;

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-top: 40px;
  padding-bottom: 80px;
`;

const EmptyResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: center;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

const EmptyResultTitle = styled.h3`
  ${({ theme }) => theme.typography.UI18SB};
  color: ${({ theme }) => theme.color.gray700};
`;

const EmptyResultOffer = styled.p`
  ${({ theme }) => theme.typography.UI15R};
  color: ${({ theme }) => theme.color.gray500};
  white-space: pre-line;
`;
